import React from 'react';

const config = {
  Compliant: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  Overdue: 'bg-red-50 text-red-700 border-red-200',
  'At Risk': 'bg-orange-50 text-orange-700 border-orange-200',
  'Not Started': 'bg-slate-100 text-slate-600 border-slate-200',
  Completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Active: 'bg-blue-50 text-blue-700 border-blue-200',
  Draft: 'bg-slate-100 text-slate-500 border-slate-200',
  Low: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Medium: 'bg-amber-50 text-amber-700 border-amber-200',
  High: 'bg-red-50 text-red-700 border-red-200',
  Pending: 'bg-amber-50 text-amber-700 border-amber-200',
  Accepted: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Revoked: 'bg-slate-100 text-slate-600 border-slate-200',
  Expired: 'bg-red-50 text-red-700 border-red-200',
  Invited: 'bg-blue-50 text-blue-700 border-blue-200',
};

const StatusBadge = ({ status, className = '' }) => (
  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${config[status] || 'bg-slate-100 text-slate-600 border-slate-200'} ${className}`}>
    {status}
  </span>
);

export default StatusBadge;